import { useState, useCallback, useEffect } from 'react';
import { EventData, EVENTS, STATUS, Step } from 'react-joyride';

const TOUR_KEY = 'solimat-communication-chat-tour-v1';

const BASE_STEPS: Step[] = [
  {
    target: '.comm-content',
    title: 'Hilo de comunicación',
    content: 'Aquí se muestra el asunto, el mensaje original y todas las respuestas intercambiadas con el equipo de Solimat, ordenadas cronológicamente.',
    placement: 'top',
    skipBeacon: true,
  },
  {
    target: '.comm-thread',
    title: 'Mensajes',
    content: 'Cada burbuja representa un mensaje del hilo. Los mensajes enviados por ti aparecen diferenciados de los recibidos del equipo de Solimat.',
    placement: 'top',
    skipBeacon: true,
  },
];

const REPLY_STEP: Step = {
  target: '[data-tour="comm-reply-area"]',
  title: 'Responder',
  content: 'Usa este botón para redactar una respuesta. Podrás escribir tu mensaje y adjuntar archivos antes de enviarlo.',
  placement: 'top',
  skipBeacon: true,
};

export const useCommunicationChatTour = (canReply: boolean) => {
  const [run, setRun] = useState(false);
  const [tourKey, setTourKey] = useState(0);

  const steps = canReply ? [...BASE_STEPS, REPLY_STEP] : BASE_STEPS;

  const handleCallback = useCallback((data: EventData) => {
    const { type, status, index } = data as any;
    const finished = status === STATUS.FINISHED || status === STATUS.SKIPPED;

    if (finished || (type as string) === EVENTS.TOUR_END) {
      setRun(false);
      localStorage.setItem(TOUR_KEY, 'true');
      window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: false } }));
    }

    if ((type as string) === EVENTS.STEP_AFTER && index === 0) {
      window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: false } }));
    }
  }, []);

  const startTour = useCallback(() => {
    setRun(current => {
      if (current) return false;
      setTourKey(k => k + 1);
      return true;
    });
  }, []);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: run } }));
  }, [run]);

  return { run, tourKey, steps, handleCallback, startTour };
};
